import React from 'react';
import { MainContent, ProductCatalog } from '../../components';

function SingleCategory() {
  return (
    <>
      <MainContent />
      <ProductCatalog/>
    </>
  );
}

export default SingleCategory;
